import { Observable, Subject } from 'rxjs';

/**
 * @deprecated
 * Shared part of controllers that needs to be notified about swChange calls
 *
 * It's deprecated in favor of {@link coreModule.directive:swChangeWrapper
 * swChangeWrapper directive}.
 */
export class SwChangeWrapper {
  private _swChangeSubject: Subject<any>;
  protected swChange$: Observable<any>;

  constructor() {
    this._swChangeSubject = new Subject();

    /**
     * RxJs subject that should emit every time when any of the nested swChange
     * is called.
     */
    this.swChange$ = this._swChangeSubject.asObservable();
  }

  /**
   * Function that swChange should run every time it's called.
   * @return {void} Nothing
   */
  // TS public: next(value: any)
  swChangeNext(value) {
    this._swChangeSubject.next(value);
  }
}
